import React, { useEffect, useState, useRef } from "react";
import moment from "moment";
import "../IncomeDashboard.css";
import incomeIcon from "../../../assets/images/Contributions-income.png";
import passiveIncomeIcon from "../../../assets/images/easy.png";
import activeIncomeIcon from "../../../assets/images/lift_weight.png";
import NewLoader from "../../../components/styled-components/loader/NewLoader";
import getFAClientName from "../../../helpers/getFAClientName";
import { exportElementToPaginatedPdf } from "../../../utils/pdfExport";
import { IncomePDFReport } from "./IncomePDFReport";
import { Bar } from "react-chartjs-2";
import FETCH from "../../../utils/fetch";
import { captureChartImage, sleep, waitForNextPaint } from "../../../utils/chartExport";

export const IncomeReport = React.forwardRef(({ data, isLoading, monthlyDataReport, yearlyDataReport, incomeReport, chartData, onDownloadLoading }, ref) => {
  const [clientName, setClientName] = useState("");
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [pdfIncomeList, setPdfIncomeList] = useState([]);
  const [chartImage, setChartImage] = useState(null);
  const chartRef = useRef(null);
  const latestLoadingRef = useRef(isLoading);
  const latestChartDataRef = useRef(chartData);

  useEffect(() => {
    latestLoadingRef.current = isLoading;
    latestChartDataRef.current = chartData;
  }, [isLoading, chartData]);

  React.useImperativeHandle(ref, () => ({
    downloadPDF: () => {
      downloadPDF();
    },
    isDownloading: downloadLoading,
  }));

  const fetchAllIncomeForPDF = async () => {
    let allData = [];
    let page = 1;
    let hasMore = true;
    const limit = 1000;
    const userRole = localStorage.getItem("role") !== "undefined" && JSON.parse(localStorage.getItem("role"));
    const ID = localStorage.getItem("accessId");

    while (hasMore) {
      let datares = await FETCH.post({
        url: "client-module-service/client-module/list",
        id: userRole === "Financial Advisor Client"
            ? `?module=Income&page=${page}&limit=${limit}&clientId=${ID}`
            : `?module=Income&page=${page}&limit=${limit}`,
        body: {},
      });

      if (datares && datares.records && datares.records.length > 0) {
        allData = [...allData, ...datares.records];
        if (datares.records.length < limit) {
          hasMore = false;
        } else {
          page++;
        }
      } else {
        hasMore = false;
      }
    }
    return allData;
  };

  const downloadPDF = async () => {
    try {
      setDownloadLoading(true);
      if (onDownloadLoading) onDownloadLoading(true);

      for (let i = 0; i < 30; i += 1) {
        const latestChartData = latestChartDataRef.current;
        const hasChartData =
          latestChartData &&
          Array.isArray(latestChartData.labels) &&
          latestChartData.labels.length > 0 &&
          Array.isArray(latestChartData.datasets) &&
          latestChartData.datasets.length > 0;

        if (!latestLoadingRef.current && hasChartData) {
          break;
        }

        await waitForNextPaint();
        await sleep(200);
      }

      await waitForNextPaint();

      // 1. Capture chart after the hidden export chart has actually rendered.
      const capturedChartImage = await captureChartImage({
        chartRef,
        getCanvas: () => chartRef.current && chartRef.current.canvas,
        minImageLength: 500,
      });
      setChartImage(capturedChartImage);

      // 2. FETCH ALL DATA
      const allIncome = await fetchAllIncomeForPDF();
      setPdfIncomeList(allIncome);

      // 3. GENERATE PDF
      setTimeout(async () => {
        const element = document.getElementById("income-report-pdf");
        if (!element) {
          setDownloadLoading(false);
          if (onDownloadLoading) onDownloadLoading(false);
          return;
        }

        await exportElementToPaginatedPdf({
          element,
          fileName: `Income_Report_${moment().format("YYYYMMDD")}.pdf`,
          margin: 15,
        });
        setDownloadLoading(false);
        if (onDownloadLoading) onDownloadLoading(false);
      }, 1000);

    } catch (error) {
      console.error("Error generating PDF:", error);
      setDownloadLoading(false);
      if (onDownloadLoading) onDownloadLoading(false);
    }
  };

  const incomeReportCards = [
    {
      id: 1,
      name: "Active Income",
      thisYear:
      incomeReport &&
      incomeReport.yearlyActiveIncome ?
        parseFloat(incomeReport.yearlyActiveIncome)
          .toFixed(2)
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",") :0,
      thisMonth:
      incomeReport &&
      incomeReport.monthlyActiveIncome ?
        parseFloat(incomeReport.monthlyActiveIncome)
          .toFixed(2)
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",") :0,
      icon: activeIncomeIcon,
      total: "123456",
    },
    {
      id: 2,
      name: "Passive Income",
      thisYear:
      incomeReport &&
      incomeReport.yearlyPassiveIncome ?
        parseFloat(incomeReport.yearlyPassiveIncome)
          .toFixed(2)
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",") :0,
      thisMonth:
      incomeReport &&
      incomeReport.monthlyPassiveIncome ?
        parseFloat(incomeReport.monthlyPassiveIncome)
          .toFixed(2)
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",") :0,
      icon: passiveIncomeIcon,
      total: "123456",
    },
  ];

  useEffect(()=>{
    const name = getFAClientName();
    if (name) setClientName(name);
  },[])

  return (
    <React.Fragment>
      <div className="incomeCard1">
        <h3 className="Reportheading">Income</h3>
        <div className="incomeRow">
          <div>
            <div className="budget-home-icon-container" style={{ gap: "4px" }}>
              <div
                className="asset-home-icon"
                style={{ textAlign: "center", width: "48%" }}
              >
                <img
                  style={{ width: "100%", minWidth: "100px" }}
                  src={incomeIcon}
                  alt="incomeIcon"
                />
              </div>
              <div style={{ textAlign: "center", width: "49%" }}>
                <div className="incomeCardConatiner">
                  <h3
                    className="Reportheading"
                    style={{
                      fontSize: "16px",
                      fontWeight: "900",
                    }}
                  >
                    Year to date
                  </h3>
                  <h3 className="Reportheading" style={{ fontWeight: "700" }}>
                    ${" "}
                    {incomeReport &&
                      incomeReport.totalYearly ?
                      incomeReport.totalYearly
                        .toFixed(2)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",") :0}
                  </h3>
                </div>
                <div className="incomeCardConatiner">
                  <h3
                    className="Reportheading"
                    style={{
                      fontSize: "16px",
                      fontWeight: "900",
                    }}
                  >
                    This Month
                  </h3>
                  <h3 className="Reportheading" style={{ fontWeight: "700" }}>
                    ${" "}
                    {incomeReport &&
                      incomeReport.totalMonthly ?
                      incomeReport.totalMonthly
                        .toFixed(2)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",") :0}
                  </h3>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div className="reportrow">
              <div className="reportrowData">
                <span className="reportTitle"> Client Name</span>
                <span className="reportsubTitle">
                {clientName || localStorage.getItem("User") || ""}
                </span>
              </div>
              <div className="reportrowData">
                <span className="reportTitle"> Today's Date </span>
                <span className="reportsubTitle">
                  {" "}
                  {moment().format("MM/DD/YYYY")}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      {incomeReportCards &&
        incomeReportCards.map((item, index) => (
          <div className="incomeCard2" key={index}>
            <div className="budget-home-icon-container" style={{ gap: "4px" }}>
              <h3 className="incomeReportMainHaeding">{item.name}</h3>

              <div
                className="asset-home-icon"
                style={{ textAlign: "center", width: "35%" }}
              >
                <img
                  style={{ width: "100%", minWidth: "100px" }}
                  src={item.icon}
                  alt="incomeIcon"
                />
              </div>
            </div>
            <div className="incomeRow">
              <div>
                <div className="IncomeRowMonth">
                  <span className="IncomeRowMonthHeading"> This Month</span>
                  <span className="IncomeRowMonthValue">${item.thisMonth}</span>
                </div>
                <div className="IncomeRowMonth" style={{ marginTop: "1rem" }}>
                  <span className="IncomeRowMonthHeading">Year to Date </span>
                  <span className="IncomeRowMonthValue"> ${item.thisYear}</span>
                </div>
              </div>
            </div>
          </div>
        ))}

      {/* Hidden container for PDF capture */}
      <div style={{ position: "fixed", top: 0, left: "-3000px", zIndex: -9999, opacity: 0.01, pointerEvents: "none" }}>
        <div style={{ width: "950px" }}>
          <Bar
            ref={chartRef}
            data={chartData || { labels: [], datasets: [] }}
            options={{
              animation: { duration: 0 },
              responsive: false,
              maintainAspectRatio: false,
              scales: {
                xAxes: [{ stacked: true }],
                yAxes: [{ stacked: true }]
              }
            }}
            height={400}
            width={900}
          />
        </div>
        <div id="income-report-pdf">
          <IncomePDFReport
            incomeList={pdfIncomeList}
            incomeReport={incomeReport}
            chartImage={chartImage}
            clientName={clientName || localStorage.getItem("User") || ""}
          />
        </div>
      </div>
    </React.Fragment>
  );
});
